import(/* webpackMode: "eager", webpackExports: ["MobileNav"] */ "/vercel/path0/app/(docs)/_components/mobile-nav.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/(docs)/docs.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
